import { render, staticRenderFns } from "./queryCurrencies.vue?vue&type=template&id=7e23d253&scoped=true"
import script from "./queryCurrencies.vue?vue&type=script&lang=js"
export * from "./queryCurrencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e23d253",
  null
  
)

export default component.exports